var map = {
	"./template.bet575": 1663,
	"./template.bet575.tsx": 1663,
	"./template.bet777": 2096,
	"./template.bet777.tsx": 2096,
	"./template.betbetbet": 2097,
	"./template.betbetbet.tsx": 2097,
	"./template.betgalaxy": 2098,
	"./template.betgalaxy.tsx": 2098,
	"./template.betprofessor": 2011,
	"./template.betprofessor.tsx": 2011,
	"./template.betroyale": 2099,
	"./template.betroyale.tsx": 2099,
	"./template.betstride": 2100,
	"./template.betstride.tsx": 2100,
	"./template.buffalobet": 2101,
	"./template.buffalobet.tsx": 2101,
	"./template.chromabet": 2102,
	"./template.chromabet.tsx": 2102,
	"./template.default": 676,
	"./template.default.tsx": 676,
	"./template.epicodds": 2103,
	"./template.epicodds.tsx": 2103,
	"./template.fiestabet": 2012,
	"./template.fiestabet.tsx": 2012,
	"./template.forsport": 1664,
	"./template.forsport.tsx": 1664,
	"./template.gigabet": 2104,
	"./template.gigabet.tsx": 2104,
	"./template.goldenbet888": 1665,
	"./template.goldenbet888.tsx": 1665,
	"./template.goldenrush": 2105,
	"./template.goldenrush.tsx": 2105,
	"./template.hyperbet": 2106,
	"./template.hyperbet.tsx": 2106,
	"./template.juicybet": 1666,
	"./template.juicybet.tsx": 1666,
	"./template.junglebet": 1667,
	"./template.junglebet.tsx": 1667,
	"./template.magnumbet": 2107,
	"./template.magnumbet.tsx": 2107,
	"./template.oldgill": 1668,
	"./template.oldgill.tsx": 1668,
	"./template.puntcity": 1669,
	"./template.puntcity.tsx": 1669,
	"./template.puntgenie": 2108,
	"./template.puntgenie.tsx": 2108,
	"./template.pyramidbet": 2109,
	"./template.pyramidbet.tsx": 2109,
	"./template.questbet": 1670,
	"./template.questbet.tsx": 1670,
	"./template.slambet": 2013,
	"./template.slambet.tsx": 2013,
	"./template.sterlingparker": 2014,
	"./template.sterlingparker.tsx": 2014,
	"./template.sugarcastle": 2110,
	"./template.sugarcastle.tsx": 2110,
	"./template.templebet": 2111,
	"./template.templebet.tsx": 2111,
	"./template.titanbet": 2112,
	"./template.titanbet.tsx": 2112,
	"./template.ts": 89,
	"./template.vikingbet": 1671,
	"./template.vikingbet.tsx": 1671,
	"./template.volcanobet": 2113,
	"./template.volcanobet.tsx": 2113,
	"./template.wellbet": 1672,
	"./template.wellbet.tsx": 1672
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2470;